/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import getAllUrlParams from '../../shared/utils/getAllUrlParams';
import Header from './components/presentational/Header';
import CalendarContent from './components/presentational/CalendarContent';

const PageWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.hideNav || props.viewType === 'weekView' ? '0px' : '49px')};
  padding-top: ${(props) => (!props.hideNav && props.viewType === 'weekView' ? '49px' : '')};
  height: ${(props) => (props.hideNav || props.viewType === 'weekView' ? '100%' : 'calc(100% - 49px)')};
  width: 100%;
  background: ${({ theme }) => theme.colors.backgroundApp};
  color: ${({ theme }) => theme.colors.text};
`;

const IconSideBarAndContentWrapper = styled('div')`
  display: flex;
  position: relative;
  height: ${(props) => {
    if (props.viewType === 'weekView') return '100%';
    if (props.isTvMode) return '100%';
    if (props.headerHeight) return `calc(100% - ${props.headerHeight}px)`;
    return 'calc(100% - 61.5px)';
  }};
  /* headerHeight is null until Header measures itself after mount, which is
     reachable now that week view can be the entry view - fall back to the
     same measured default the height rule above uses, so the columns don't
     sit under the fixed header for a frame. */
  padding-top: ${(props) => (props.viewType === 'weekView' && !props.isTvMode ? `${props.headerHeight || 61.5}px` : '')};
  ${(props) => props.viewType === 'weekView' && 'min-width: fit-content;'}
`;

const CalendarLayout = () => {
  const headerHeight = useSelector((state) => state.calendar.data.headerHeight);
  const viewType = useSelector((state) => state.calendar.data.viewType);
  const isTvMode = useSelector((state) => state.calendar.ui.isTvMode);
  const urlParams = getAllUrlParams(window.location.href, false);
  const hideNav = urlParams.hideNav === 'true' || isTvMode;

  return (
    <PageWrapper viewType={viewType} hideNav={hideNav}>
      {!isTvMode && <Header />}
      <IconSideBarAndContentWrapper
        headerHeight={headerHeight}
        viewType={viewType}
        isTvMode={isTvMode}
      >
        <CalendarContent />
      </IconSideBarAndContentWrapper>
    </PageWrapper>
  );
};

export default CalendarLayout;
